<template>
	<div id="countdown" v-if="counterObj">
		<b-row>
			<b-col cols="auto" class="text-center">
				<h3 class="m-0">{{ counterObj.days }}</h3>
				<p class="m-0 lead">{{$t('countdown.days')}}</p>
			</b-col>
			<b-col cols="auto" class="text-center">
				<h3 class="m-0">{{ counterObj.hours }}</h3>
				<p class="m-0 lead">{{$t('countdown.hours')}}</p>
			</b-col>
			<b-col cols="auto" class="text-center">
				<h3 class="m-0">{{ counterObj.minutes }}</h3>
				<p class="m-0 lead">{{$t('countdown.minutes')}}</p>
			</b-col>
			<b-col cols="auto" class="text-center">
				<h3 class="m-0">{{ counterObj.seconds }}</h3>
				<p class="m-0 lead">{{$t('countdown.seconds')}}</p>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				counterObj: null,
				counterInt: null
			}
		},
		computed: {
			asset() {
				return this.$store.getters.asset
			}
		},
		methods: {
			initCountdown() {
				const now = this.$moment()
				const end = this.$moment.utc(this.asset.broadcasting_estimated_start)
				const diff = end - now
				const dur = this.$moment.duration(end.diff(now)).asSeconds()
				const days = Math.floor(dur / (3600*24))
				const hours = Math.floor(dur % (3600*24) / 3600)
				const minutes = Math.floor(dur % 3600 / 60)
				const seconds = Math.floor(dur % 60)
				if(diff > 0) {
					this.counterObj = {
						days: days,
						hours: hours,
						minutes: minutes,
						seconds: seconds
					}
				} else {
					this.reset(true)
				}
			},
			reset(val) {
				clearInterval(this.counterInt)
				this.counterInt = null
				this.counterObj = null
				this.$emit('cdStarting', val)
			}
		},
		mounted() {
			this.initCountdown()
			if(this.asset && this.asset.broadcasting_estimated_start) this.counterInt = setInterval(this.initCountdown, 1000)
		},
		watch: {
			asset(data) {
				this.reset(false)
				if(data.broadcasting_estimated_start) this.counterInt = setInterval(this.initCountdown, 1000)
			}
		}
	}
</script>
